import React from 'react';
import { Routes, Route, Navigate, Link } from 'react-router-dom';
import FileList from './components/FileList';
import FileViewer from './components/FileViewer';
import PlaylistViewer from './components/PlaylistViewer';
import Support from './components/Support';
import Privacy from './components/Privacy';
import { FaGooglePlay, FaApple, FaAmazon } from 'react-icons/fa';

const appStores = [
  { id: 'android', label: 'Google Play', url: 'https://play.google.com/store/apps/details?id=com.codeandtech.namapages_mobile', Icon: FaGooglePlay },
  { id: 'apple', label: 'App Store', url: 'https://apps.apple.com/us/app/namapages/id6751823784', Icon: FaApple },
  { id: 'amazon', label: 'Amazon Appstore', url: 'https://www.amazon.com/dp/B0FQ8ZGNGF?lv=shuf&channelId=500&plpRedirect=mhFallback', Icon: FaAmazon }
];

function getDeviceStore() {
  const userAgent = (navigator.userAgent || '').toLowerCase();
  if (/iphone|ipad|ipod/.test(userAgent)) return 'apple';
  if (/kindle|silk\//.test(userAgent)) return 'amazon';
  if (/android/.test(userAgent)) return 'android';
  return null;
}

function App() {
  const deviceStore = getDeviceStore();
  return (
    <div className="np-page">
      {/* ── Temple Header ── */}
      <header className="np-header" style={{ marginBottom: '1rem', borderRadius: '0 0 16px 16px' }}>
        {/* Left deity */}
        <img
          src="/images/radha_krishna.jpg"
          alt="Radha Krishna"
          className="np-header-deity-img"
        />

        {/* Centre title block */}
        <div className="np-header-title-wrap">
          <h1 className="np-header-title">Namapages</h1>
          <p className="np-header-tagline">✦ नाम परते साधन नाहीं ✦</p>
          {/* Nav links */}
          <nav style={{ display: 'flex', gap: '1rem', marginTop: '0.4rem', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Link to="/" style={navLinkStyle}>🏠 Home</Link>
            <Link to="/support" style={navLinkStyle}>🙏 Support</Link>
            <Link to="/privacy" style={navLinkStyle}>🔒 Privacy</Link>
          </nav>
          <div className={`np-app-downloads ${deviceStore ? 'np-app-downloads--device' : ''}`} aria-label="Download the Namapages mobile app">
            {appStores.map(({ id, label, url, Icon }) => (
              <a key={id} className={`np-app-download ${deviceStore === id ? 'is-recommended' : ''}`} href={url} target="_blank" rel="noopener noreferrer" title={`Download Namapages on ${label}`}>
                <Icon aria-hidden="true" />
                <span>{label}</span>
              </a>
            ))}
          </div>
        </div>

        {/* Right deity */}
        <img
          src="/images/vittal_rakhumayi.jpg"
          alt="Vittal Rakhumayi"
          className="np-header-deity-img"
        />
      </header>

      {/* Decorative gold divider */}
      <hr className="np-divider" />

      <Routes>
        <Route path="/" element={<FileList />} />
        <Route path="/file/:folder/:language/:fileName" element={<FileViewer />} />
        <Route path="/playlist/:playlistId" element={<PlaylistViewer />} />
        <Route path="/support" element={<Support />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {/* Footer */}
      <footer style={{
        marginTop: '3rem',
        padding: '1rem',
        textAlign: 'center',
        borderTop: '1px solid var(--border-gold)',
        fontFamily: 'var(--font-body)',
        fontStyle: 'italic',
        fontSize: '0.8rem',
        color: 'var(--text-muted)',
        letterSpacing: '0.5px'
      }}>
        ✦ Namapages — Preserving the Sacred Musical Heritage of Dakshina Bharatha Sampradaya ✦
      </footer>
    </div>
  );
}

const navLinkStyle = {
  fontFamily: 'var(--font-heading)',
  fontSize: '0.7rem',
  fontWeight: '700',
  letterSpacing: '1px',
  color: 'var(--brown-deep)',
  textDecoration: 'none',
  opacity: 0.85,
  transition: 'opacity 0.18s, background 0.18s',
  padding: '2px 8px',
  borderRadius: '4px',
  border: '1px solid rgba(62,31,0,0.15)',
};

export default App;
